let URL = () => {
    let url;
if(process.env.NODE_ENV === 'development') {
  url = "http://85.159.211.76:90"
} else {
  url = "https://vivanode.com"
}

return url;
}

export default URL;